export const getMenuData = [
  // {
  //   category: true,
  //   title: 'Dashboards',
  // },
  // Dashboards
  {
    title: 'Dashboard',
    key: 'sudashboard',
    icon: 'fe fe-home',
    url: '/superadmin/dashboard',
    roles: ['superadmin'],
    module: 'core',
  },
  // Plans
  {
    title: 'Plans',
    key: 'plans',
    icon: 'fe fe-slack',
    url: '/superadmin/plans',
    roles: ['superadmin'],
    module: 'core',
  },
  // Boards
  {
    title: 'Boards',
    key: 'boards',
    icon: 'fe fe-clipboard',
    url: '/superadmin/boards',
    roles: ['superadmin'],
    module: 'core',
  },
  // Schools
  {
    title: 'Schools',
    key: 'schools',
    icon: 'fe fe-book-open',
    url: '/superadmin/schools',
    roles: ['superadmin'],
    module: 'core',
  },
  // Manage School
  {
    title: 'Manage School',
    key: 'schoolmanage',
    // url: '/admin/exam/manage/',
    roles: ['superadmin'],
    module: 'core',
    hide: true,
  },
  // Admin Menu
  {
    title: 'Dashboard',
    key: 'dashboard',
    icon: 'fe fe-home',
    url: '/dashboard',
    roles: ['admin', 'supervisor', 'staff', 'teacher'],
    module: 'core',
    permission: 'dashboard-menu-visible',
  },
  // Notify
  {
    title: 'Notify',
    key: 'sendnotifications',
    icon: 'fe fe-send',
    // url: '/send-notifications',
    roles: ['admin', 'supervisor', 'staff', 'teacher'],
    module: 'notify',
    permission: 'notify-menu-visible',
    children: [
      {
        title: 'School Notification',
        key: 'schoolnotification',
        url: '/school-notification',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'notify',
        permission: 'schoolnotification-submenu-visible',
      },
      {
        title: 'Exam Result Send',
        key: 'examresultsend',
        url: '/exam-result-send',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'notify',
        permission: 'examresultsend-submenu-visible',
      },
    ],
  },
  // E-Learning
  {
    title: 'E-Learning',
    key: 'elearning',
    icon: 'fe fe-book-open',
    roles: ['admin', 'supervisor', 'staff', 'teacher'],
    module: 'homework',
    permission: 'elearning-menu-visible',
    children: [
      {
        title: 'Homework',
        key: 'homework',
        url: '/homework',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'homework',
        permission: 'examresultsend-submenu-visible',
      },
    ],
  },
  {
    title: 'Students',
    key: 'students',
    icon: 'fa fa-mortar-board',
    roles: ['admin', 'supervisor', 'staff', 'teacher'],
    module: 'core',
    permission: 'students-menu-visible',
    children: [
      {
        title: 'Manage Students',
        key: 'managestudents',
        url: '/students',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'core',
        permission: 'managestudents-submenu-visible',
      },
      {
        title: 'Student Photos',
        key: 'studentphotos',
        url: '/student-photos',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'core',
        permission: 'studentphotos-submenu-visible',
      },
      {
        title: 'Reports',
        key: 'studentreports',
        url: '/student-reports',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'core',
        permission: 'studentreports-submenu-visible',
      },
      {
        title: 'Attendance Reports',
        key: 'studentattendancereport',
        url: '/student-attendance-report',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'core',
        permission: 'studentreports-submenu-visible',
      },
      {
        title: 'Downloads',
        key: 'studentattendanceexport',
        url: '/student-attendance-export',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'core',
        permission: 'studentreports-submenu-visible',
      },
    ],
  },
  // Staff
  {
    title: 'Staffs',
    key: 'staffs',
    icon: 'fe fe-briefcase',
    roles: ['admin', 'supervisor', 'staff', 'teacher'],
    module: 'core',
    permission: 'staffs-menu-visible',
    children: [
      {
        title: 'Staff Grades',
        key: 'staffgrades',
        url: '/staffgrades',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'core',
        permission: 'staffgrades-submenu-visible',
      },
      {
        title: 'Manage Staffs',
        key: 'managestaffs',
        url: '/staffs',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'core',
        permission: 'managestaffs-submenu-visible',
      },
      {
        title: 'Take Attendance',
        key: 'takeattendance',
        url: '/takeattendance',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'core',
        permission: 'takeattendance-submenu-visible',
      },
      {
        title: 'Attendance Report',
        key: 'attendancereport',
        url: '/attendancereport',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'core',
        permission: 'attendancereport-submenu-visible',
      },
      {
        title: 'Manage Attendance',
        key: 'updatestaffattendance',
        url: '/staffattendance/manage',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'core',
        permission: 'updatestaffattendance-submenu-visible',
      },
    ],
  },
  // Academic
  {
    title: 'Academic Settings',
    key: 'academicsettings',
    icon: 'fe fe-sliders',
    roles: ['admin', 'supervisor', 'staff', 'teacher'],
    module: 'core',
    permission: 'academicsettings-menu-visible',
    children: [
      {
        title: 'Sessions',
        key: 'sessions',
        url: '/sessions',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'core',
        permission: 'sessions-submenu-visible',
      },
      {
        title: 'Promotions',
        key: 'promotion',
        url: '/promotion',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'core',
        permission: 'promotion-submenu-visible',
      },
      {
        title: 'Sections',
        key: 'sections',
        url: '/sections',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'core',
        permission: 'sections-submenu-visible',
      },
      {
        title: 'Subjects',
        key: 'subjects',
        url: '/subjects',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'core',
        permission: 'subjects-submenu-visible',
      },
      {
        title: 'Internals',
        key: 'internalassessments',
        url: '/internal_assessments',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'core',
        permission: 'internalassessments-submenu-visible',
      },
      {
        title: 'Classes',
        key: 'schoolclasses',
        url: '/classes',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'core',
        permission: 'schoolclasses-submenu-visible',
      },
      {
        title: 'Class Setup',
        key: 'classsetup',
        url: '/classsetup',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'core',
        permission: 'classsetup-submenu-visible',
      },
      {
        title: 'Timetables',
        key: 'timetables',
        url: '/timetables',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'timetable',
        permission: 'timetables-submenu-visible',
      },
    ],
  },
  // Backoffice
  {
    title: 'Back Office',
    key: 'backoffice',
    icon: 'fe fe-monitor',
    roles: ['admin', 'supervisor', 'staff', 'teacher'],
    module: 'core',
    permission: 'backoffice-menu-visible',
    children: [
      {
        title: 'Calendar',
        key: 'calendar',
        url: '/backoffice/calendar',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'calendar',
        permission: 'calendar-submenu-visible',
      },
      {
        title: 'Attendance',
        key: 'studentattendance',
        url: '/backoffice/attendance',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'attendance',
        permission: 'studentattendance-submenu-visible',
      },
      {
        title: 'Leave Request',
        key: 'studentleaverequest',
        url: '/backoffice/leaverequests',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'attendance',
        permission: 'studentleaverequest-submenu-visible',
      },
      {
        title: 'ID Cards',
        key: 'studentidcards',
        url: '/backoffice/idcards',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'idcard',
        permission: 'studentidcards-submenu-visible',
      },
      {
        title: 'Subject Groups',
        key: 'subjectgroup',
        url: '/backoffice/subject-group',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'onlineapplication',
        permission: 'subjectgroup-submenu-visible',
      },
      {
        title: 'Application Forms',
        key: 'applicationforms',
        url: '/backoffice/application-forms',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'onlineapplication',
        permission: 'applicationforms-submenu-visible',
      },
      {
        title: 'Parent Registration',
        key: 'parentregistration',
        url: '/backoffice/parentregistration',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'core',
        permission: 'parentregistration-submenu-visible',
      },
      {
        title: 'Certificate Generation',
        key: 'certificategeneration',
        url: '/backoffice/certificategeneration',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'core',
        permission: 'certificategeneration-submenu-visible',
      },
      {
        title: 'Applicants',
        key: 'applicants',
        url: '/backoffice/applicants',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'onlineapplication',
        hide: true,
        permission: 'applicants-submenu-visible',
      },
    ],
  },
  // Fee Management
  {
    title: 'Accounts',
    key: 'feemanagement',
    icon: 'fe fe-dollar-sign',
    roles: ['admin', 'supervisor', 'staff', 'teacher'],
    module: 'fee',
    permission: 'feemanagement-menu-visible',
    children: [
      {
        title: 'Fees',
        key: 'fees',
        url: '/fees',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'fee',
        permission: 'fees-submenu-visible',
      },
      {
        title: 'Manage Fees',
        key: 'managefees',
        url: '/backoffice/managefees',
        roles: ['admin', 'supervisor', 'staff', 'teacher'], // 29072022: Added teacher role as it wasnt visible in menu
        module: 'fee',
        permission: 'managefees-submenu-visible',
      },
      {
        title: 'Fee Summary',
        key: 'feesummary',
        url: '/backoffice/feesummary',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'fee',
        permission: 'feesummary-submenu-visible',
      },
      {
        title: 'Pay Fees',
        key: 'payfees',
        url: '/backoffice/payfees',
        roles: ['admin', 'supervisor', 'staff', 'teacher'], // 29072022: !s
        module: 'fee',
        permission: 'payfees-submenu-visible',
      },
      {
        title: 'Fee Export',
        key: 'feeexport',
        url: '/backoffice/fee-export',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'fee',
        permission: 'feeexport-submenu-visible',
      },
      {
        title: 'Order\'s Bills',
        key: 'ordersbills',
        url: '/account/orders',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'inventory',
        permission: 'inventoryorderbill-submenu-visible',
      },
      {
        title: 'Orders Report',
        key: 'ordersreports',
        url: '/inventory/reports',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'inventory',
        permission: 'inventoryorderreport-submenu-visible',
      },
      {
        title: 'Downloads',
        key: 'accountdownloads',
        url: '/account/exports',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'fee',
        permission: 'accountexports-submenu-visible',
      },
    ],
  },
  // BOSEM
  {
    title: 'Exam',
    key: 'bosemexam',
    icon: 'fe fe-award',
    roles: ['admin', 'supervisor', 'staff', 'teacher'],
    module: 'bosemexam',
    permission: 'bosemexam-menu-visible',
    children: [
      // Exam type
      {
        title: 'Exam Types',
        key: 'exam_types',
        url: '/bosemexam/types',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'bosemexam',
        permission: 'bosemexamtypes-submenu-visible',
      },
      // schools exam
      {
        title: 'Exams',
        key: 'school_exams',
        url: '/bosemexam/schoolexams',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'bosemexam',
        permission: 'bosemschoolexam-submenu-visible',
      },
      // exam setting
      {
        title: 'Exam Setting',
        key: 'exam_setting',
        url: '/bosemexam/examsetting',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'bosemexam',
        permission: 'bosemexamsetting-submenu-visible',
        // hide: true,
      },
      // manage exam
      {
        title: 'Manage Exam',
        key: 'manage_exams',
        url: '/bosemexam/manages',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'bosemexam',
        permission: 'bosemmanageexam-submenu-visible',
      },
      // exam management
      {
        title: 'Exam Management',
        key: 'exam_manage',
        // url: '/admin/exam/manage/',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'bosemexam',
        hide: true,
        permission: 'bosemexammanage-submenu-visible',
      },
      // exam admitcard
      {
        title: 'Exam Admitcards',
        key: 'exam_admitcard',
        // url: '/admin/exam/manage/',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'bosemexam',
        hide: true,
        permission: 'bosemexamadmitcard-submenu-visible',
      },
      // report card
      {
        title: 'Report Card',
        key: 'report_cards',
        url: '/bosemexam/reportcard/',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'bosemexam',
        // hide: true,
        permission: 'bosemreportcards-submenu-visible',
      },
      // Final Result
      {
        title: 'Final Results',
        key: 'manage_final',
        url: '/bosemexam/manage_final',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'bosemexam',
        permission: 'bosemmanagefinal-submenu-visible',
      },
    ],
  },
  // Exam
  {
    title: 'Exam',
    key: 'exam',
    icon: 'fe fe-award',
    roles: ['admin', 'supervisor', 'staff', 'teacher'],
    module: 'exam',
    permission: 'exam-menu-visible',
    children: [
      {
        title: 'Exam Types',
        key: 'examtypes',
        url: '/exam/types',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'exam',
        permission: 'examtypes-submenu-visible',
      },
      {
        title: 'Exams',
        key: 'schoolexams',
        url: '/exam/schoolexams',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'exam',
        permission: 'schoolexams-submenu-visible',
      },
      {
        title: 'Exam Setting',
        key: 'examsetting',
        url: '/exam/examsetting',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'exam',
        // hide: true,
      },
      {
        title: 'Manage Exam',
        key: 'manageexam',
        url: '/exam/manage',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'exam',
        permission: 'managefinal-submenu-visible',
      },
      {
        title: 'Exam Management',
        key: 'exammanage',
        // url: '/admin/exam/manage/',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'exam',
        hide: true,
        permission: 'exammanage-submenu-visible',
      },
      {
        title: 'Exam Admitcards',
        key: 'examadmitcard',
        // url: '/admin/exam/manage/',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'exam',
        hide: true,
        permission: 'examadmitcard-submenu-visible',
      },
      {
        title: 'Exam Grades',
        key: 'examgrades',
        url: '/exam/grades',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'exam',
        permission: 'examgrades-submenu-visible',
      },
      {
        title: 'Class Exam Grades',
        key: 'classexamgrades',
        url: '/exam/class-grades',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'exam',
        permission: 'classexamgrades-submenu-visible',
      },
      // report card
      {
        title: 'Report Card',
        key: 'reportcard',
        url: '/exam/reportcard/',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'exam',
        // hide: true,
      },
      {
        title: 'Final Results',
        key: 'managefinal',
        url: '/exam/managefinal',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'exam',
        permission: 'managefinal-submenu-visible',
      },
      {
        title: 'Internal Marks',
        key: 'internalmarks',
        url: '/exam/internal_marks',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'exam',
        permission: 'internalmarks-submenu-visible',
      },
      // {
      //   title: 'Final Result Report 1',
      //   key: 'finalresultreport',
      //   // url: '/admin/exam/manage/',
      //   roles: ['admin', 'supervisor', 'staff', 'teacher'],
      //   module: 'exam',
      //   hide: true,
      // },
    ],
  },
  // Online Exam
  {
    title: 'Online Exam',
    key: 'onlineexam',
    icon: 'fe fe-globe',
    roles: ['admin', 'supervisor', 'staff', 'teacher'],
    module: 'onlineexam',
    permission: 'onlineexam-menu-visible',
    children: [
      {
        title: 'Exam Types',
        key: 'onlineexamtypes',
        url: '/online-exam/types',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'onlineexam',
        permission: 'onlineexamtypes-submenu-visible',
      },
      {
        title: 'Exams',
        key: 'manageonlineexam',
        url: '/online-exams',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'onlineexam',
        permission: 'manageonlineexam-submenu-visible',
      },
      {
        title: 'Online Exam Questions',
        key: 'onlineexamquestions',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'onlineexam',
        hide: true,
        permission: 'onlineexamquestions-submenu-visible',
      },
      {
        title: 'Exam Instructions',
        key: 'examinstructions',
        url: '/online-exam/instructions',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'onlineexam',
        permission: 'examinstructions-submenu-visible',
      },
    ],
  },
  // Setting
  {
    title: 'Settings',
    key: 'settings',
    icon: 'fe fe-settings',
    roles: ['admin', 'supervisor', 'staff', 'teacher'],
    module: 'core',
    permission: 'settings-menu-visible',
    children: [
      {
        title: 'Institute Settings',
        key: 'institutesettings',
        url: '/settings/institute',
        roles: ['admin', 'supervisor', 'teacher', 'staff'],
        module: 'core',
        permission: 'institutesettings-submenu-visible',
      },
      {
        title: 'User Profile',
        key: 'profilesettings',
        url: '/settings/profile',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'core',
        permission: 'profilesettings-submenu-visible',
      },
      {
        title: 'Manage Users',
        key: 'manageusers',
        url: '/settings/users',
        roles: ['admin', 'supervisor'],
        module: 'core',
        permission: 'manageusers-submenu-visible',
      },
      // Role management
      {
        title: 'Manage Roles',
        key: 'manageroles',
        url: '/settings/roles',
        roles: ['admin', 'supervisor'],
        module: 'core',
        permission: 'manageroles-submenu-visible',
      },
      {
        title: 'Modules',
        key: 'modules',
        url: '/settings/modules',
        roles: ['admin', 'supervisor'],
        module: 'core',
        permission: 'modules-submenu-visible',
      },
    ],
  },
  // Inventory
  {
    title: 'Inventory',
    key: 'inventory',
    icon: 'fe fe-clipboard',
    roles: ['admin', 'supervisor', 'staff', 'teacher'],
    module: 'inventory',
    permission: 'inventory-menu-visible',
    children: [
      {
        title: 'Dashboard',
        key: 'inventorydashboard',
        url: '/inventory/dashboard',
        roles: ['admin', 'supervisor', 'teacher', 'staff'],
        module: 'inventory',
        permission: 'inventorydashboard-submenu-visible',
      },
      {
        title: 'Categories',
        key: 'categories',
        url: '/inventory/categories',
        roles: ['admin', 'supervisor', 'teacher', 'staff'],
        module: 'inventory',
        permission: 'inventorycategories-submenu-visible',
      },
      {
        title: 'Products',
        key: 'products',
        url: '/inventory/products',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'inventory',
        permission: 'inventoryproducts-submenu-visible',
      },
      {
        title: 'Orders',
        key: 'orders',
        url: '/inventory/orders',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'inventory',
        permission: 'inventoryorders-submenu-visible',
      },
      {
        title: 'Product Transactions',
        key: 'producttransactions',
        url: '/inventory/product_transactions',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'inventory',
        permission: 'inventoryproducttransactions-submenu-visible',
      },
      {
        title: 'Bundled Products',
        key: 'bundledproducts',
        url: '/inventory/bundled_products',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'inventory',
        permission: 'inventorybundledproducts-submenu-visible',
      },
      {
        title: 'Bundled Transactions',
        key: 'bundledtransactions',
        url: '/inventory/bundled_transactions',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'inventory',
        permission: 'inventorybundledtransactions-submenu-visible',
      },
      {
        title: 'Reports',
        key: 'reports',
        url: '/inventory/reports',
        roles: ['admin', 'supervisor', 'staff', 'teacher'],
        module: 'inventory',
        permission: 'inventoryreports-submenu-visible',
      },
    ],
  },
  // Hostel
  {
    title: 'Hostel',
    key: 'hostel',
    icon: 'fe fe-home',
    roles: ['admin', 'supervisor', 'staff', 'teacher'],
    module: 'inventory',
    permission: 'inventory-menu-visible',
    children: [
      {
        title: 'Hostels',
        key: 'hostels',
        url: '/hostel/add',
        roles: ['admin', 'supervisor', 'teacher', 'staff'],
        module: 'inventory',
        permission: 'inventorydashboard-submenu-visible',
      },
      {
        title: 'Blocks',
        key: 'blocks',
        url: '/hostel/blocks',
        roles: ['admin', 'supervisor', 'teacher', 'staff'],
        module: 'inventory',
        permission: 'inventorydashboard-submenu-visible',
      },
      {
        title: 'Facilities',
        key: 'facilities',
        url: '/hostel/facilities',
        roles: ['admin', 'supervisor', 'teacher', 'staff'],
        module: 'inventory',
        permission: 'inventorydashboard-submenu-visible',
      },
      {
        title: 'Rooms',
        key: 'rooms',
        url: '/hostel/rooms',
        roles: ['admin', 'supervisor', 'teacher', 'staff'],
        module: 'inventory',
        permission: 'inventorydashboard-submenu-visible',
      },
      {
        title: 'Enrollments',
        key: 'enrollments',
        url: '/hostel/enrollments',
        roles: ['admin', 'supervisor', 'teacher', 'staff'],
        module: 'inventory',
        permission: 'inventorydashboard-submenu-visible',
      },
      {
        title: 'Pocket Money',
        key: 'pocketmoney',
        url: '/hostel/pocket-money',
        roles: ['admin', 'supervisor', 'teacher', 'staff'],
        module: 'inventory',
        permission: 'inventorydashboard-submenu-visible',
      },
    ],
  },
  // Support request
  {
    title: 'Support',
    key: 'support',
    icon: 'fe fe-bus',
    roles: ['admin', 'supervisor', 'staff', 'teacher'],
    module: 'support',
    permission: 'support-menu-visible',
    children: [
      {
        title: 'Requests',
        key: 'requests',
        url: '/support/requests',
        roles: ['admin', 'supervisor', 'teacher', 'staff'],
        module: 'support',
        permission: 'supportrequests-submenu-visible',
      },
    ],
  },
  // Library
  {
    title: 'Library',
    key: 'library',
    icon: 'fe fe-bus',
    roles: ['admin', 'supervisor', 'staff', 'teacher'],
    module: 'library',
    permission: 'library-menu-visible',
    children: [
      {
        title: 'Books',
        key: 'books',
        url: '/library/books',
        roles: ['admin', 'supervisor', 'teacher', 'staff'],
        module: 'library',
        permission: 'supportrequests-submenu-visible',
      },
      {
        title: 'Categories',
        key: 'category',
        url: '/library/category',
        roles: ['admin', 'supervisor', 'teacher', 'staff'],
        module: 'library',
        permission: 'supportrequests-submenu-visible',
      },
      {
        title: 'Issue/Return',
        key: 'issue',
        url: '/library/issue',
        roles: ['admin', 'supervisor', 'teacher', 'staff'],
        module: 'library',
        permission: 'supportrequests-submenu-visible',
      },
    ],
  },
  // Transport
  {
    title: 'Transport',
    key: 'transport',
    icon: 'fe fe-bus',
    roles: ['admin', 'supervisor', 'staff', 'teacher'],
    module: 'transport',
    permission: 'transport-menu-visible',
    children: [
      {
        title: 'Vehicles',
        key: 'vehicles',
        url: '/transport/vehicle',
        roles: ['admin', 'supervisor', 'teacher', 'staff'],
        module: 'transport',
        permission: 'supportrequests-submenu-visible',
      },
      {
        title: 'Routes',
        key: 'routes',
        url: '/transport/route',
        roles: ['admin', 'supervisor', 'teacher', 'staff'],
        module: 'transport',
        permission: 'supportrequests-submenu-visible',
      },
      // {
      //   title: 'Drivers',
      //   key: 'drivers',
      //   url: '/transport/driver',
      //   roles: ['admin', 'supervisor', 'teacher', 'staff'],
      //   module: 'transport',
      //   permission: 'supportrequests-submenu-visible',
      // },
    ],
  },
  // Student Pages
  {
    title: 'Dashboard',
    key: 'studentdashboard',
    icon: 'fe fe-home',
    url: '/student/dashboard',
    roles: ['normal'],
    module: 'core',
  },
  // Online Exam
  {
    title: 'Online Exam',
    key: 'onlineexam',
    icon: 'fe fe-award',
    url: '/student/online-exams',
    roles: ['normal'],
    module: 'core',
  },
  // {
  //   title: 'Dashboards',
  //   key: 'dashboard',
  //   icon: 'fe fe-home',
  //   count: 7,
  //   children: [
  //     {
  //       title: 'Dashboard',
  //       key: 'dashboard',
  //       url: '/dashboard',
  //     },
  //     {
  //       title: 'Analytics',
  //       key: 'dashboardAnalytics',
  //       url: '/dashboard/analytics',
  //     },
  //     {
  //       title: 'Statistics',
  //       key: 'dashboardStatistics',
  //       url: '/dashboard/statistics',
  //     },
  //     {
  //       title: 'Ecommerce',
  //       key: 'dashboardEcommerce',
  //       url: '/dashboard/ecommerce',
  //     },
  //     {
  //       title: 'Crypto',
  //       key: 'dashboardCrypto',
  //       url: '/dashboard/crypto',
  //     },
  //     {
  //       title: 'Jira',
  //       key: 'dashboardJira',
  //       url: '/dashboard/jira',
  //     },
  //     {
  //       title: 'Helpdesk',
  //       key: 'dashboardHelpdesk',
  //       url: '/dashboard/helpdesk',
  //     },
  //   ],
  // },
  // {
  //   category: true,
  //   title: 'Apps & Pages',
  //   roles: ['admin', 'supervisor', 'staff', 'teacher'],
  // },
  // {
  //   title: 'System Pages',
  //   key: 'system',
  //   icon: 'fe fe-user',
  //   roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //   children: [
  //     {
  //       title: 'Login',
  //       key: 'systemLogin',
  //       url: '/system/login',
  //       roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //     },
  //     {
  //       title: 'Forgot Password',
  //       key: 'systemForgotPassword',
  //       url: '/system/forgot-password',
  //       roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //     },
  //     {
  //       title: 'Register',
  //       key: 'systemRegister',
  //       url: '/system/register',
  //       roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //     },
  //     {
  //       title: 'Lockscreen',
  //       key: 'systemLockscreen',
  //       url: '/system/lockscreen',
  //       roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //     },
  //     {
  //       title: 'Page 404',
  //       key: 'system404',
  //       url: '/system/404',
  //       roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //     },
  //     {
  //       title: 'Page 500',
  //       key: 'system500',
  //       url: '/system/500',
  //       roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //     },
  //   ],
  // },
  // {
  //   title: 'Ecommerce',
  //   key: 'ecommerce',
  //   icon: 'fe fe-shopping-cart',
  //   roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //   children: [
  //     {
  //       title: 'Dashboard',
  //       key: 'ecommerceDashboard',
  //       url: '/ecommerce/dashboard',
  //       roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //     },
  //     {
  //       title: 'Orders',
  //       key: 'ecommerceOrders',
  //       url: '/ecommerce/orders',
  //       roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //     },
  //     {
  //       title: 'Propduct Catalog',
  //       key: 'ecommerceProductCatalog',
  //       url: '/ecommerce/product-catalog',
  //       roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //     },
  //     {
  //       title: 'Product Details',
  //       key: 'ecommerceProductDetails',
  //       url: '/ecommerce/product-details',
  //       roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //     },
  //     {
  //       title: 'Cart',
  //       key: 'ecommerceCart',
  //       url: '/ecommerce/cart',
  //       roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //     },
  //   ],
  // },
  // {
  //   title: 'Apps',
  //   key: 'apps',
  //   icon: 'fe fe-database',
  //   roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //   children: [
  //     {
  //       title: 'Messaging',
  //       key: 'appsCart',
  //       url: '/apps/messaging',
  //       roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //     },
  //     {
  //       title: 'Calendar',
  //       key: 'appsCalendar',
  //       url: '/apps/calendar',
  //       roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //     },
  //     {
  //       title: 'Mail',
  //       key: 'appsMail',
  //       url: '/apps/mail',
  //       roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //     },
  //     {
  //       title: 'Profile',
  //       key: 'appsProfile',
  //       url: '/apps/profile',
  //       roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //     },
  //     {
  //       title: 'Gallery',
  //       key: 'appsGallery',
  //       url: '/apps/gallery',
  //       roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //     },
  //   ],
  // },
  // {
  //   title: 'Extra Apps',
  //   key: 'extraApps',
  //   icon: 'fe fe-hard-drive',
  //   children: [
  //     {
  //       title: 'Github Explore',
  //       key: 'extraAppsGithubExplore',
  //       url: '/extra-apps/github-explore',
  //         roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //        },
  //     {
  //       title: 'Github Discuss',
  //       key: 'extraAppsGithubDiscuss',
  //       url: '/extra-apps/github-discuss',
  //         roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //       },
  //     {
  //       title: 'Digitalocean Droplets',
  //       key: 'extraAppsDigitaloceanDroplets',
  //       url: '/extra-apps/digitalocean-droplets',
  //         roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //         },
  //     {
  //       title: 'Digitalocean Create',
  //       key: 'extraAppsDigitaloceanCreate',
  //       url: '/extra-apps/digitalocean-create',
  //         roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //        },
  //     {
  //       title: 'Google Analytics',
  //       key: 'extraAppsGoogleAnalytis',
  //       url: '/extra-apps/google-analytics',
  //         roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //        },
  //     {
  //       title: 'Wordpress Post',
  //       key: 'extraAppsWordpressPost',
  //       url: '/extra-apps/wordpress-post',
  //         roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //        },
  //     {
  //       title: 'Wordpress Posts',
  //       key: 'extraAppsWordpressPosts',
  //       url: '/extra-apps/wordpress-posts',
  //         roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //        },
  //     {
  //       title: 'Wordpress Add',
  //       key: 'extraAppsWordpressAdd',
  //       url: '/extra-apps/wordpress-add',
  //         roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //        },
  //     {
  //       title: 'Todoist List',
  //       key: 'extraAppsTodoistList',
  //       url: '/extra-apps/todoist-list',
  //         roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //        },
  //     {
  //       title: 'Jira Dashboard',
  //       key: 'extraAppsJiraDashboard',
  //       url: '/extra-apps/jira-dashboard',
  //         roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //        },
  //     {
  //       title: 'Jira Agile Board',
  //       key: 'extraAppsJiraAgileBoard',
  //       url: '/extra-apps/jira-agile-board',
  //         roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //        },
  //     {
  //       title: 'Helpdesk Dashboard',
  //       key: 'extraAppsHelpdeskDashboard',
  //       url: '/extra-apps/helpdesk-dashboard',
  //         roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //        },
  //   ],
  // },
  // {
  //   category: true,
  //   title: 'Components',
  // },
  // {
  //   title: 'Bootstrap',
  //   key: 'bootstrap',
  //   icon: 'fe fe-bookmark',
  //   url: '/ui-kits/bootstrap',
  //   roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //  },
  // {
  //   title: 'Ant Design',
  //   key: 'antDesign',
  //   icon: 'fe fe-bookmark',
  //   url: '/ui-kits/antd',
  //   roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //  },
  // {
  //   title: 'Widgets',
  //   key: 'widgets',
  //   icon: 'fe fe-image',
  //   count: 47,
  //   roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //   children: [
  //     {
  //       title: 'General',
  //       key: 'widgetsGeneral',
  //       url: '/widgets/general',
  //       roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //     },
  //     {
  //       title: 'Lists',
  //       key: 'widgetsLists',
  //       url: '/widgets/lists',
  //       roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //     },
  //     {
  //       title: 'Tables',
  //       key: 'widgetsTables',
  //       url: '/widgets/tables',
  //       roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //     },
  //     {
  //       title: 'Charts',
  //       key: 'widgetsCharts',
  //       url: '/widgets/charts',
  //       roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //     },
  //   ],
  // },
  // {
  //   title: 'Cards',
  //   key: 'cards',
  //   icon: 'fe fe-credit-card',
  //   children: [
  //     {
  //       title: 'Basic Cards',
  //       key: 'cardsBasicCards',
  //       url: '/cards/basic-cards',
  //         roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //        },
  //     {
  //       title: 'Tabbed Cards',
  //       key: 'cardsTabbedCards',
  //       url: '/cards/tabbed-cards',
  //         roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //        },
  //   ],
  // },
  // {
  //   title: 'Tables',
  //   key: 'tables',
  //   icon: 'fe fe-pie-chart',
  //   roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //   children: [
  //     {
  //       title: 'Bootstrap',
  //       key: 'tablesBootstrap',
  //       url: '/tables/bootstrap',
  //       roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //     },
  //     {
  //       title: 'Ant Design',
  //       key: 'tablesAntd',
  //       url: '/tables/antd',
  //       roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //     },
  //   ],
  // },
  // {
  //   title: 'Charts',
  //   key: 'charts',
  //   icon: 'fe fe-home',
  //   children: [
  //     {
  //       title: 'Chartist.js',
  //       key: 'chartsChartistjs',
  //       url: '/charts/chartistjs',
  //         roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //        },
  //     {
  //       title: 'Chart.js',
  //       key: 'chartsChartjs',
  //       url: '/charts/chartjs',
  //         roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //        },
  //     {
  //       title: 'C3',
  //       key: 'chartsC3',
  //       url: '/charts/c3',
  //         roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //        },
  //   ],
  // },
  // {
  //   title: 'Icons',
  //   key: 'icons',
  //   icon: 'fe fe-star',
  //   roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //   children: [
  //     {
  //       title: 'Feather Icons',
  //       key: 'iconsFeatherIcons',
  //       url: '/icons/feather-icons',
  //       roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //     },
  //     {
  //       title: 'Fontawesome',
  //       key: 'iconsFontawesome',
  //       url: '/icons/fontawesome',
  //       roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //     },
  //     {
  //       title: 'Linearicons Free',
  //       key: 'iconsLineariconsFree',
  //       url: '/icons/linearicons-free',
  //       roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //     },
  //     {
  //       title: 'Icomoon Free',
  //       key: 'iconsIcomoonFree',
  //       url: '/icons/icomoon-free',
  //       roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //     },
  //   ],
  // },
  // {
  //   category: true,
  //   title: 'Advanced',
  // },
  // {
  //   title: 'Form Examples',
  //   key: 'formExamples',
  //   icon: 'fe fe-menu',
  //   url: '/advanced/form-examples',
  //   roles: ['admin', 'supervisor', 'staff', 'teacher'],
  // },
  // {
  //   title: 'Email Templates',
  //   key: 'emailTemplates',
  //   icon: 'fe fe-mail',
  //   url: '/advanced/email-templates',
  //     roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //     },
  // {
  //   title: 'Pricing Tables',
  //   key: 'pricingTables',
  //   icon: 'fe fe-command',
  //   url: '/advanced/pricing-tables',
  //     roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //     },
  // {
  //   title: 'Invoice',
  //   key: 'invoice',
  //   icon: 'fe fe-file-text',
  //   url: '/advanced/invoice',
  //     roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //     },
  // {
  //   title: 'Utilities',
  //   key: 'utilities',
  //   icon: 'fe fe-inbox',
  //   url: '/advanced/utilities',
  //     roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //     },
  // {
  //   title: 'Grid',
  //   key: 'grid',
  //   icon: 'fe fe-grid',
  //   url: '/advanced/grid',
  //     roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //     },
  // {
  //   title: 'Typography',
  //   key: 'typography',
  //   icon: 'fe fe-type',
  //   url: '/advanced/typography',
  //     roles: ['admin', 'supervisor', 'staff', 'teacher'],
  //     },
]
